import type { StaticSharedField } from './types';
import type { quantityDropdownValue } from '/business/shared/components/pages/question/types';
import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_NUMBER,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useMakeTravelDistance({
  distanceDropdownValues,
  label,
  subLabel,
  hasAsterisk,
}: {
  distanceDropdownValues?: quantityDropdownValue[];
  label?: React.ReactNode | string;
  subLabel?: string;
  hasAsterisk?: boolean;
}): StaticSharedField {
  const shouldIncludeDropdown = distanceDropdownValues !== undefined;
  const displaySelectFlag = !distanceDropdownValues || distanceDropdownValues.length === 0;
  return {
    type: FIELD_TYPE_NUMBER,
    propName: 'distance_travelled',
    element: 'distance_travelled',
    placeholderI18nKey: ' ',
    label: label || <>Total distance travelled</>,
    subLabel: subLabel ? <span>{subLabel}</span> : null,
    titleHasAsterisk: hasAsterisk ?? true,
    validation: [
      ...(hasAsterisk
        ? [
            {
              rule: ERR_TYPE_REQUIRED,
              errCode: 'ERRNOTRAVELDISTANCE',
              errStr: 'Please enter a valid distance',
            },
          ]
        : []),
      {
        rule: ERR_TYPE_NUM_SMALL,
        errCode: 'ERRTRAVELDISTANCETOOLOW',
        errStr: 'Please enter a valid distance',
        value: 0,
      },
      {
        rule: ERR_TYPE_NUM_LARGE,
        errCode: 'ERRTRAVELDISTANCETOOHIGH',
        errStr: 'Please enter a valid distance',
        value: 9999999,
      },
    ],
    ...(shouldIncludeDropdown
      ? {
          dropdown: {
            defaultValue: displaySelectFlag ? 'select' : distanceDropdownValues[0].name,
            propName: 'distance_travelled_unit',
            values: displaySelectFlag
              ? [
                  {
                    name: 'select',
                    displayName: 'Select unit',
                  },
                ]
              : distanceDropdownValues.map((value) => ({
                  name: value.name,
                  displayName: value.displayName,
                })),
          },
        }
      : {}),
  };
}
